export const ModelType = Object.freeze({
    CUSTOMERS: "Customers",
    PRODUCTS: "Products",
    DISTRIBUTOR: "Distributor"
});

export function modelTypeToIndex(modelType) {

    switch (modelType) {
        case ModelType.CUSTOMERS:
            return 0;
        case ModelType.PRODUCTS:
            return 1;
        case ModelType.DISTRIBUTOR:
            return 2;
        default:
            return null
    }
}